export enum AssetSortOptions {
    DATE_MODIFIED = 'dateModified',
    NAME = 'name',
    SIZE = 'size',
}
